import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FaceRecognitionUIService } from './faceRecognitionUI.service';

@Component({
  selector: 'app-face-recognition-ui',
  templateUrl: './faceRecognitionUI.component.html',
  styleUrls: ['./faceRecognitionUI.component.css']
})
export class FaceRecognitionUIComponent implements OnInit {
  @Input() referenceCode: any = null;
  @Input() pageCode: number = 424;
  trainedData: any[];
  label: any;
  system: any;
  isAlreadyCaptured = false;

  constructor(private faceRecognitionService: FaceRecognitionUIService) { }

  ngOnInit() {
    this.getTrainDataList();
  }

  getTrainDataList() {
    this.faceRecognitionService.getAllTrainedData().subscribe((res: any) => {
      const result = res.filter((dt: any) => dt.Descriptors !== null);
      this.trainedData = result.map((singleTrainData: any) => {
        const json = atob(singleTrainData.Descriptors);     // -> '{"0":-0.18,"1":0.04,...}'
const obj = JSON.parse(json);        // -> { "0": -0.18, "1": 0.04, ... }
const arr = Object.keys(obj)
  .sort((a, b) => Number(a) - Number(b))
  .map(k => Number(obj[k]));         // -> number[]

        return {
          ...singleTrainData,
          Descriptors: arr
        };
      });
      /// only send trainded data which has full 128 array of descriptors data
      if (this.trainedData.length > 0) {
        this.trainedData = this.trainedData.filter(f => f.Descriptors ? f.Descriptors.length === 128 : '');
      }
    });
  }
  getData(e) {
    const obj = {
      Reference_Code: this.referenceCode,
      Page_Code: this.pageCode,
      Name: e._label,
      Descriptors: JSON.stringify(e._descriptors[0]),
      System: e.system
    };
    this.faceRecognitionService.addFaceIdentityDetails(obj).subscribe((resp) => {
      this.getTrainDataList();
    });
  }

  getRecognizationPersonData(e) {
    debugger
    console.log('recognization person', e);
    if (!e || typeof e !== 'string') {
      this.isAlreadyCaptured = false;
      return;
    }
    const normalized = e.trim().toLowerCase();
    this.isAlreadyCaptured = normalized.indexOf('unknown') !== 0;
  }
}
